<header [ngClass]="{ sticky: isSticky, 'p-0 pt-3 pb-3 pb-lg-0': true }">
  <div class='container d-flex flex-row flex-lg-row flex-wrap'>
    <div
      class='flex-lg-grow-1 align-content-stretch flex-wrap m-auto m-lg-0 order-0 order-lg-0'>
      <a class='Header-container_logo navbar-brand' href='/'>
        <img alt='Retreva Logo' src='/assets/images/retail/logo.png' />
      </a>
    </div>
    <div
      class='d-inline-block d-lg-flex w-lg-auto order-3 order-lg-1'
      style='width: 100%'>
      <div class='flex-lg-grow-1'>
        <div
          class='h-100 align-items-end d-lg-flex p-0 collapse'
          id='navbarSupportedContent'>
          <ul
            class='mr-auto mb-0 pt-4 d-flex align-content-stretch align-items-end flex-lg-row flex-column'>
            <li
              *ngFor='let item of menuItems | async'
              class='h-100 d-flex align-items-end w-lg-100'>
              <a
                [routerLink]="['/' + item.target]"
                class='Header-container_links_navbar_menu_item_link m-auto m-lg-0'
              >{{ item.label }}</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div
      class='d-flex d-lg-inline-block flex-grow-1 align-items-center align-items-lg-center order-1 order-lg-2'>
      <div>
        <ul class='mb-0 mb-lg-3 mt-0'>
          <li
            *ngIf='(isUserAuthenticated$ | async) === false'
            class='pull-left ms-1 ms-sm-2'>
            <app-button
              [color]="'blue'"
              [route]="['/register']"
              [size]="'small'"
              [text]="'Sign up'"></app-button>
          </li>
          <li
            *ngIf='(isUserAuthenticated$ | async) === false'
            class='pull-left ms-1 ms-sm-2'>
            <app-button
              [color]="'orange'"
              [route]="['/login']"
              [size]="'small'"
              [text]="'Login'"></app-button>
          </li>
          <li
            *ngIf='(isUserAuthenticated$ | async) === true'
            class='pull-left ms-1 ms-sm-0'>
            <app-button
              [Click]='logout'
              [color]="'orange'"
              [size]="'small'"
              [text]="'Logout'"></app-button>
          </li>
        </ul>
      </div>
    </div>
    <div class='flex-grow-1 d-flex d-lg-none align-items-center ml-3 order-2'>
      <button
        aria-controls='navbarSupportedContent'
        aria-expanded='false'
        aria-label='Toggle navigation'
        class='ml-auto float-right d-lg-none'
        data-target='#navbarSupportedContent'
        data-toggle='collapse'
        type='button'>
        <span class='navbar-toggler-icon'></span>
      </button>
    </div>
  </div>
</header>
